import React from 'react'
import "../style/Footer.css";


function Footer() {
  return (
    <div className='footer'>Footer
    </div>
  )
}

export default Footer